import { render, staticRenderFns } from "./WithdrawalManagement.vue?vue&type=template&id=00647a88"
import script from "./WithdrawalManagement.vue?vue&type=script&lang=js"
export * from "./WithdrawalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports